<div
  class="arrow"
  [ngClass]="{ tail: tail, secondary: secondary, spin: spinning }"
  [ngStyle]="{ transform: 'rotate(' + rotate + ')' }"
></div>
